<template>
  <div class="about-us">
    <div class="about-us__slogan">
      <p class="about-us__slogan-text">
        El <u>arte</u> de administrar datos para <strong>dar forma</strong> a tu
        <i>futuro</i>.
      </p>
    </div>

    <div class="about-us__title">
      <img src="@/assets/logo.svg" alt="DataCraft STUDIOS" class="about-us__logo" loading="lazy"/>
      <h1 class="about-us__main-title">DataCraft</h1>
      <h2 class="about-us__sub-title">Agencia de Growth Digital</h2>
    </div>
  </div>
</template>

<style scoped>
@import "@/css/variables.css";

/* Estilos generales */
.about-us {
  display: flex;
  width: 50vw;
  gap: 50px;
  justify-content: center;
  margin: auto;
}

.about-us__slogan,
.about-us__title {
  flex-basis: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.about-us__slogan {
  font-size: 4.5rem;
  color: var(--color-accent);
  font-family: var(--font-sans);
}

.about-us__logo {
  width: 20rem;
  height: 20rem;

}

.about-us__main-title {
  font-family: var(--font-homenaje);
  font-size: 6.5rem;
  color: var(--color-text);
  font-weight: lighter;
  margin: 0;
}

.about-us__sub-title {
  font-family: var(--font-homenaje);
  font-size: 2rem;
  color: var(--color-primary);
  font-weight: lighter;
  margin-top: -10px;
}

strong {
  color: var(--color-accent);
}

/* Flexbox responsive */
@media screen and (max-width: 768px) {
  .about-us {
    flex-direction: column;
  }

  .about-us__logo {
    width: 150px;
    height: 150px;
  }

  .about-us__main-title {
    font-size: 4rem;
  }

  .about-us__sub-title {
    font-size: 1rem;
  }

  .about-us__slogan-text {
    font-size: 1.8rem;
    margin: 50px 0 -40px;
  }
}
</style>
